import { validate } from 'uuid';

import { ReachNodeId } from '~app-client/core/types';

export function isValidNodeId(
	id: ReachNodeId,
	extraValidIds: ReachNodeId[] = []
): id is ReachNodeId {
	return (extraValidIds || []).includes(id) || validate(id);
}
